<!--Wrapper Start-->
<div style="background: #101e2a;">
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div class="pr-4 pt-4" id="sidebar-wrapper" *ngIf="showSideMenu">
      <button id="close_sidebar">
        <img
          src="assets/images/close.png"
          width="16"
          alt="Close Button Image"
        />
      </button>
      <span class="sidebar-logo">
        <img class="pointer" src="/assets/images/bars.png" (click)="showSideMenuFn()" alt="Line Bars Image" width="27"/>
        <img src="assets/images/logo.png" alt="Site Logo" width="200" style="margin-left:7px;"/>
      </span>
      <div class="list-group list-group-flush mt-5">
        <a routerLink="/image-editor" [ngClass]="{ active: !selectedType }"
          >CREATE TEMPLATE</a
        >
        <a routerLinkActive="active" id="toggle_menu" routerLink="/panel"
          >READY-MADE TEMPLATES
          <img
            src="assets/images/angle_down.png"
            class="angle_down"
            width="10"
            alt="Angle Down Image"
        /></a>
        <a routerLinkActive="active" id="toggle_menu" routerLink="/users" *ngIf="isAdmin">USERS LIST</a>
        <div class="drop_menu">
          <a
            class="dropdown-item pointer"
            *ngFor="let type of allTemplatesType"
            href="panel/{{ type.id }}"
          >
            {{ type.name }}
          </a>
        </div>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->

    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav class="navbar navbar-expand-lg navbar-light pb-4">
        <button
          class="btn btn-primary"
          id="menu-toggle"
          *ngIf = "!showSideMenu"
          (click)="showSideMenuFn()"
        >
          <img src="assets/images/bars.png" alt="Line Bars Image" />
        </button>
        <div class="" style="padding-left: 80%;">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0" style="display:inline-block">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle pr-0"
                id="navbarDropdown"
                role="button"
                (click)="showMenuFn()"
              >
                <img
                  src="assets/images/user.png"
                  width="50"
                  class="img-fluid"
                  alt="User Image"
                />
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                style="display: block;"
                *ngIf="showMenu"
              >
                <a class="dropdown-item" href="#"
                  ><img
                    src="assets/images/settings.png"
                    alt="Settings Image"
                    width="20"
                  />Setting</a
                >
                <a class="dropdown-item" (click)="Logout()"
                  ><img
                    src="assets/images/logout.png"
                    alt="Logout Image"
                    width="20"
                  />Log Out</a
                >
              </div>
            </li>
          </ul>
          <div style="color: #fff; margin-left:7px;display: inline-block;max-width: 130px;word-break: break-word">{{userLogged.name}}</div>
        </div>
      </nav>
      <div class="row" *ngIf="isAdmin">
        <div class="col-sm-4">
          <select class="form-control" [(ngModel)]="selectedType">
            <option [value]="0">Select Type</option>
            <option [value]="types.id" *ngFor="let types of allTemplatesType">
              {{ types.name }}
            </option>
          </select>
        </div>
      </div>
      <div width="100%">
        <tui-image-editor [options]="editorobject"></tui-image-editor>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
</div>
